module.exports = __webpack_public_path__ + "img/img55.64f9ab90.svg";